import React, { useState } from "react";
import "./selectindividualpotmodal.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import { addCommas } from "../../helpers/helpers";

const SelectIndividualPotModal = (props) => {
  const { multiDrawdownWithdraw } = props;
  const [selected, setSelected] = useState(
    props.memberships === undefined
      ? multiDrawdownWithdraw?.memberships?.find(
          (membership) => membership.status === "unLocked",
        )
      : props.memberships?.memberships?.length &&
          props.memberships?.memberships?.length ===
            multiDrawdownWithdraw?.memberships?.length &&
          !multiDrawdownWithdraw?.memberships?.some(
            (membership) => membership.status === "locked",
          )
        ? multiDrawdownWithdraw?.memberships?.find(
            (membership) => membership.status === "unLocked",
          )
        : props.memberships?.memberships?.length &&
            props.memberships?.memberships?.length !==
              multiDrawdownWithdraw?.memberships?.length &&
            multiDrawdownWithdraw?.memberships?.some(
              (membership) => membership.status === "locked",
            )
          ? props.memberships?.memberships[0]
          : props.memberships,
  );
  function handleCheck(item) {
    setSelected(item);
  }

  return (
    <div className="ir-manage-membership-modal-container">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="ir-manage-membership-modal-body">
        <div className="ir-parent-heading d-none d-xl-flex d-lg-flex d-md-flex">
          <div className="margin-left">
            <p className="ir-heading mb-3">{props.modalTitle}</p>
            <span className="mb-3">You can select one pot at a time.</span>
          </div>
          <div className="ir-parent-total-value">
            <div className="ir-total-value-head">Total value</div>
            <span className="ir-total-value">
              £{addCommas(Math.trunc(props?.multiDrawdownWithdraw?.totalFund))}.
              <span className="ir-subset-value">
                {(props?.multiDrawdownWithdraw?.totalFund % 1)
                  .toFixed(2)
                  .substring(2)}
              </span>
            </span>
          </div>
        </div>
        <div className="d-block d-sm-none">
          <div>
            <p className="ir-heading mb-3">{props.modalTitle}</p>
          </div>
          <div className="mb-3">You can select one pot at a time.</div>
          <div className="ir-parent-total-value">
            <div className="">Total value</div>
            <span className="">
              £{addCommas(props?.multiDrawdownWithdraw?.totalFund)}
            </span>
          </div>
        </div>
        {props.multiDrawdownWithdraw?.status === "locked" ||
        props?.multiDrawdownWithdraw?.memberships.some(
          (membership) => membership.status === "locked",
        ) ? (
          <div className="ir-locked-text d-flex mt-3">
            <span className="ir-locked-pad">
              <Icons iconname="locked" variant="icon-sixteen-px" />
            </span>
            <p className="ir-locked-text-pad">
              One or more of your pots has a change underway and will reopen
              when your change is complete.
            </p>
          </div>
        ) : (
          ""
        )}
        <Row className="drawdown-position">
          {props?.multiDrawdownWithdraw?.memberships
            ?.filter((item) => parseFloat(item.totalFund) !== 0)
            ?.map((item, index) => {
              return (
                <Col
                  key={index}
                  className={
                    props?.multiDrawdownWithdraw.status === "locked"
                      ? "ir-pot-items pot-lock-bg mb-3"
                      : item.status === "locked"
                        ? "ir-pot-items pot-lock-bg mb-3"
                        : selected?.membershipId === item.membershipId
                          ? "ir-pot-items mb-3 ir-pot-items-bg"
                          : "ir-pot-items mb-3"
                  }
                  xs={12}
                  sm={12}
                  md={3}
                  lg={3}
                  xl={3}
                >
                  {props?.multiDrawdownWithdraw.status === "locked" ||
                  item.status === "locked" ? (
                    <div className="manage-custom-checkbox ir-custom-checkbox-align text-end">
                      <Icons iconname="locked" variant="icon-sixteen-px" />
                    </div>
                  ) : (
                    <CustomCheckbox
                      name="pot"
                      potId={index}
                      variantName="manage-custom-checkbox ir-custom-checkbox-align text-end"
                      onChange={() => handleCheck(item)}
                      defaultChecked={
                        selected?.membershipId === item.membershipId
                      }
                    />
                  )}

                  <p className="ir-pot-value-id">{item.membershipId}</p>
                  <p className="ir-pot-value-head">{item.membershipName}</p>
                  <p className="ir-pot-total-value">
                    £{addCommas(item.totalFund)}
                  </p>
                </Col>
              );
            })}
        </Row>
        <span className="ir-corrected-date mb-3 date-position">
          Figures correct as of {props.multiDrawdownWithdraw?.correctDate}
        </span>
        <Row className="d-flex justify-content-between">
          <Buttons
            name="Back"
            className="secondary mt-3"
            handleClick={props.handleCloseButton}
          />
          <Buttons
            name="Continue"
            className="primary mt-3 me-4"
            handleClick={() => props.handleContinueButton(selected)}
          />
        </Row>
      </div>
    </div>
  );
};

export default SelectIndividualPotModal;
